import React from 'react';
import TagElement from './TagElement';
import Button from '../../components/buttons/Button';
import Icon from '../../components/icons/Icon';

type TagsListElementProps = {
    id: string;
    name: string;
    color: string;
    handleClickTag: (tagId: string) => void;
    handleClickEdit: (tagId: string) => void;
    isSelected?: boolean;
};

const TagsListElement: React.FC<TagsListElementProps> = ({
    id,
    name,
    color,
    handleClickTag,
    handleClickEdit,
    isSelected,
}) => {
    return (
        <div id={`tag-${id}`} className={`TagsListElement`}>
            <div className="w-full flex items-center justify-between">
                <TagElement name={name} color={color} onClick={() => handleClickTag(id)} />
                {!isSelected && <Button onClick={() => handleClickEdit(id)}>...</Button>}
                {isSelected && <Icon name="block-style-tick" />}
            </div>
        </div>
    );
};

export default TagsListElement;
